import { render, staticRenderFns } from "./SnssaiMainPage.vue?vue&type=template&id=24fa6454&scoped=true&"
import script from "./SnssaiMainPage.vue?vue&type=script&lang=js&"
export * from "./SnssaiMainPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24fa6454",
  null
  
)

export default component.exports